module.exports = __webpack_public_path__ + "media/images/bnr-referal-f45e2ea35b9f331f3a1575040224be03.png";